(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"] && !Shopify.designMode) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["simp-category-reveal"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('[data-simp-category-reveal]');
    if (!roots.length) return;

    roots.forEach((root) => {
      if (root.dataset.initialized === 'true') return;
      root.dataset.initialized = 'true';

      const cards = [...root.querySelectorAll('[data-category-card]')];
      const mobileQuery = window.matchMedia('(max-width: 800px)');

      const updateState = (card, index) => {
        const progress = [...card.querySelectorAll('[data-progress] span')];
        const nextIndex = Math.max(0, Math.min(index, progress.length - 1));

        card.dataset.activeIndex = String(nextIndex);
        card.style.setProperty('--active-index', nextIndex);
        progress.forEach((item, itemIndex) => item.classList.toggle('is-active', itemIndex === nextIndex));
        return nextIndex;
      };

      const setActive = (card, index, behavior = 'smooth') => {
        const track = card.querySelector('[data-media-track]');
        const progress = card.querySelector('[data-progress]');
        const nextIndex = updateState(card, index);

        if (mobileQuery.matches && progress.children.length) {
          track.scrollTo({ left: track.clientWidth * nextIndex, behavior });
        }
      };

      const getTrackIndex = (track) => {
        if (!track.clientWidth) return 0;
        return Math.round(track.scrollLeft / track.clientWidth);
      };

      cards.forEach((card) => {
        const track = card.querySelector('[data-media-track]');
        const slides = [...card.querySelectorAll('[data-slide-index]')];
        const hoverGrid = card.querySelector('[data-hover-grid]');
        const progress = card.querySelector('[data-progress]');
        let scrollFrame;

        card.style.setProperty('--slide-count', slides.length);
        updateState(card, 0);

        slides.forEach((slide, index) => {
          const title = slide.querySelector('h2')?.textContent.trim() || `Product ${index + 1}`;
          const button = document.createElement('button');
          const segment = document.createElement('span');

          button.type = 'button';
          button.dataset.hoverIndex = String(index);
          button.setAttribute('aria-label', `View ${title}, image ${index + 1}`);
          button.addEventListener('pointerenter', () => setActive(card, index));
          button.addEventListener('focus', () => setActive(card, index));
          button.addEventListener('click', () => setActive(card, index));

          if (index === 0) segment.classList.add('is-active');
          hoverGrid.append(button);
          progress.append(segment);
        });

        track.addEventListener('scroll', () => {
          if (!mobileQuery.matches) return;
          window.cancelAnimationFrame(scrollFrame);
          scrollFrame = window.requestAnimationFrame(() => updateState(card, getTrackIndex(track)));
        }, { passive: true });
      });

      const syncLayout = () => {
        cards.forEach((card) => {
          const track = card.querySelector('[data-media-track]');
          const index = Number(card.dataset.activeIndex) || 0;

          if (mobileQuery.matches) {
            track.scrollLeft = track.clientWidth * index;
          } else {
            updateState(card, index);
          }
        });
      };

      mobileQuery.addEventListener('change', syncLayout);
      window.addEventListener('resize', syncLayout, { passive: true });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["simp-movie-shot"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('[data-simp-movie-shot]');
    const svgNamespace = 'http://www.w3.org/2000/svg';

    const init = (story) => {
      if (story.dataset.simpMovieShotReady === 'true') return;
      story.dataset.simpMovieShotReady = 'true';

      const stage = story.querySelector('[data-stage]');
      const scrollZone = story.querySelector('[data-scroll-zone]');
      const scenes = [...story.querySelectorAll('[data-scene]')];
      const nextButton = story.querySelector('[data-next]');
      const ringProgress = story.querySelector('[data-ring-progress]');
      const markerLayer = story.querySelector('[data-ring-markers]');
      const ringArrow = story.querySelector('[data-ring-arrow]');
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const transitionDarkenTime = reducedMotion ? 40 : 680;
      const titleHoldTime = reducedMotion ? 320 : 1450;
      const transitionReleaseTime = reducedMotion ? 520 : 2550;
      const wheelThreshold = 150;
      const ringCircumference = 2 * Math.PI * 46;

      let activeIndex = 0;
      let autoTimer;
      let revealTimer;
      let swapTimer;
      let releaseTimer;
      let gestureResetTimer;
      let progressFrame;
      let wheelAccumulator = 0;
      let isChanging = false;
      let sceneStartedAt = performance.now();
      let timeline = { durations: [], total: 0, angles: [], markers: [] };

      const getIndex = (index) => Math.max(0, Math.min(index, scenes.length - 1));

      const canNavigate = (direction) => {
        return direction > 0 ? activeIndex < scenes.length - 1 : activeIndex > 0;
      };

      const clearTimers = () => {
        window.clearTimeout(autoTimer);
        window.clearTimeout(revealTimer);
        window.clearTimeout(swapTimer);
        window.clearTimeout(releaseTimer);
        window.cancelAnimationFrame(progressFrame);
      };

      const updateMarkers = () => {
        timeline.markers.forEach((marker, index) => {
          marker.classList.toggle('is-current', index === activeIndex);
        });
        ringArrow.style.transform = `rotate(${timeline.angles[activeIndex] || 0}deg)`;
      };

      const buildTimeline = () => {
        const durations = scenes.map((scene) => Number(scene.dataset.duration) || 7000);
        const total = durations.reduce((sum, duration) => sum + duration, 0);
        const angles = [];
        const markers = [];
        let elapsed = 0;

        markerLayer.replaceChildren();
        scenes.forEach((scene, index) => {
          const angle = total ? (elapsed / total) * 360 : 0;
          const marker = document.createElementNS(svgNamespace, 'g');
          const dot = document.createElementNS(svgNamespace, 'circle');

          marker.setAttribute('class', 'simp-movie-shot__ring-marker');
          marker.dataset.markerIndex = String(index);
          marker.setAttribute('transform', `rotate(${angle} 50 50)`);
          dot.setAttribute('cx', '50');
          dot.setAttribute('cy', '4');
          dot.setAttribute('r', '1.65');
          marker.appendChild(dot);
          markerLayer.appendChild(marker);
          angles.push(angle);
          markers.push(marker);
          elapsed += durations[index];
        });

        timeline = { durations, total, angles, markers };
        updateMarkers();
      };

      const renderProgress = (value) => {
        const progress = Math.max(0, Math.min(value, 1));
        const completedTime = timeline.durations.slice(0, activeIndex).reduce((sum, duration) => sum + duration, 0);
        const currentTime = progress * (timeline.durations[activeIndex] || 0);
        const totalProgress = timeline.total ? (completedTime + currentTime) / timeline.total : 0;

        ringProgress.style.strokeDasharray = `${ringCircumference * totalProgress} ${ringCircumference}`;
      };

      const clearGesturePreview = () => {
        window.clearTimeout(gestureResetTimer);
        stage.classList.remove('is-gesture-preview');
        stage.removeAttribute('data-wheel-direction');
        stage.style.setProperty('--wheel-progress', '0');
        wheelAccumulator = 0;
      };

      const getVideoSource = (scene) => {
        const isMobile = window.matchMedia('(max-width: 749px)').matches;
        return isMobile ? scene.dataset.mobileVideo || scene.dataset.video : scene.dataset.video;
      };

      const prepareVideo = (scene) => {
        const video = scene.querySelector('video');
        const source = getVideoSource(scene);
        if (!video) return { video: null, hasSource: false };

        if (source && video.dataset.source !== source) {
          video.src = source;
          video.dataset.source = source;
          video.load();
          video.onloadedmetadata = () => {
            if (Number.isFinite(video.duration) && video.duration > 0) {
              scene.dataset.duration = String(video.duration * 1000);
              buildTimeline();
            }
          };
        }

        if (!source && video.dataset.source) {
          video.removeAttribute('src');
          video.dataset.source = '';
          video.load();
        }

        scene.classList.toggle('has-video', Boolean(source));
        return { video, hasSource: Boolean(source) };
      };

      const scheduleAutoAdvance = (scene, remainingTime) => {
        if (activeIndex >= scenes.length - 1) return;

        const duration = Number(scene.dataset.duration) || 7000;
        const elapsed = performance.now() - sceneStartedAt;
        const delay = remainingTime ?? Math.max(500, duration + titleHoldTime - elapsed);

        window.clearTimeout(autoTimer);
        autoTimer = window.setTimeout(() => {
          if (scene === scenes[activeIndex]) goTo(activeIndex + 1);
        }, delay);
      };

      const startScene = (scene) => {
        const { video, hasSource } = prepareVideo(scene);
        const duration = Number(scene.dataset.duration) || 7000;
        sceneStartedAt = performance.now();
        renderProgress(0);

        const updateProgress = () => {
          if (scene !== scenes[activeIndex]) return;

          const elapsed = performance.now() - sceneStartedAt;
          const titleProgress = Math.min(elapsed / titleHoldTime, 1);
          let sceneProgress = titleProgress * (titleHoldTime / (titleHoldTime + duration));

          if (elapsed >= titleHoldTime) {
            const mediaProgress = hasSource && video?.duration
              ? Math.min(video.currentTime / video.duration, 1)
              : Math.min((elapsed - titleHoldTime) / duration, 1);
            const mediaWeight = duration / (titleHoldTime + duration);
            sceneProgress = (titleHoldTime / (titleHoldTime + duration)) + mediaProgress * mediaWeight;
          }

          renderProgress(sceneProgress);
          progressFrame = window.requestAnimationFrame(updateProgress);
        };

        progressFrame = window.requestAnimationFrame(updateProgress);
        revealTimer = window.setTimeout(() => {
          if (scene !== scenes[activeIndex]) return;
          scene.classList.add('is-revealing');

          if (hasSource && video) {
            video.currentTime = 0;
            video.play().catch(() => scheduleAutoAdvance(scene, duration + titleHoldTime));
            video.onended = () => {
              if (canNavigate(1)) goTo(activeIndex + 1);
            };
            video.onerror = () => scheduleAutoAdvance(scene, duration + titleHoldTime);
          }
        }, titleHoldTime);

        if (!hasSource) scheduleAutoAdvance(scene, duration + titleHoldTime);
      };

      const goTo = (requestedIndex) => {
        if (isChanging) return;

        const nextIndex = getIndex(requestedIndex);
        const currentScene = scenes[activeIndex];
        const nextScene = scenes[nextIndex];
        if (nextScene === currentScene) return;

        isChanging = true;
        clearTimers();
        clearGesturePreview();
        story.classList.add('is-changing');
        nextButton.disabled = true;
        currentScene.querySelector('video')?.pause();

        swapTimer = window.setTimeout(() => {
          currentScene.classList.remove('is-active', 'is-revealing');
          currentScene.setAttribute('aria-hidden', 'true');
          activeIndex = nextIndex;
          nextScene.classList.add('is-active');
          nextScene.setAttribute('aria-hidden', 'false');
          nextScene.classList.remove('is-revealing');
          updateMarkers();
          startScene(nextScene);
        }, transitionDarkenTime);

        releaseTimer = window.setTimeout(() => {
          story.classList.remove('is-changing');
          nextButton.disabled = false;
          isChanging = false;
        }, transitionReleaseTime);
      };

      const setWheelPreview = (direction, amount) => {
        stage.dataset.wheelDirection = direction > 0 ? 'next' : 'previous';
        stage.style.setProperty('--wheel-progress', String(Math.min(amount, 1)));
        stage.classList.add('is-gesture-preview');
      };

      const setRingHover = (event) => {
        const rect = nextButton.getBoundingClientRect();
        const x = event.clientX - (rect.left + rect.width / 2);
        const y = event.clientY - (rect.top + rect.height / 2);
        const distance = Math.sqrt(x * x + y * y);
        const radius = rect.width / 2;

        if (distance < radius * 0.28 || distance > radius * 1.05) {
          nextButton.removeAttribute('data-hover-index');
          timeline.markers.forEach((marker) => marker.classList.remove('is-hovered'));
          ringArrow.style.transform = `rotate(${timeline.angles[activeIndex] || 0}deg)`;
          return;
        }

        const angle = (Math.atan2(y, x) * 180) / Math.PI + 90;
        const normalizedAngle = (angle + 360) % 360;
        let elapsedAngle = 0;
        let targetIndex = timeline.angles.length - 1;

        timeline.durations.some((duration, index) => {
          const segmentAngle = timeline.total ? (duration / timeline.total) * 360 : 360;
          if (normalizedAngle < elapsedAngle + segmentAngle) {
            targetIndex = index;
            return true;
          }
          elapsedAngle += segmentAngle;
          return false;
        });

        nextButton.dataset.hoverIndex = String(targetIndex);
        timeline.markers.forEach((marker, index) => {
          marker.classList.toggle('is-hovered', index === targetIndex);
        });
        ringArrow.style.transform = `rotate(${timeline.angles[targetIndex] || 0}deg)`;
      };

      const clearRingHover = () => {
        nextButton.removeAttribute('data-hover-index');
        timeline.markers.forEach((marker) => marker.classList.remove('is-hovered'));
        ringArrow.style.transform = `rotate(${timeline.angles[activeIndex] || 0}deg)`;
      };

      const handleWheel = (event) => {
        if (isChanging) {
          event.preventDefault();
          return;
        }

        const direction = event.deltaY >= 0 ? 1 : -1;
        if (!canNavigate(direction)) {
          window.clearTimeout(autoTimer);
          clearGesturePreview();
          return;
        }

        event.preventDefault();
        if (wheelAccumulator !== 0 && Math.sign(wheelAccumulator) !== direction) wheelAccumulator = 0;
        if (wheelAccumulator === 0) window.clearTimeout(autoTimer);

        wheelAccumulator += event.deltaY;
        setWheelPreview(direction, Math.abs(wheelAccumulator) / wheelThreshold);
        window.clearTimeout(gestureResetTimer);

        if (Math.abs(wheelAccumulator) >= wheelThreshold) {
          goTo(activeIndex + direction);
          return;
        }

        gestureResetTimer = window.setTimeout(() => {
          clearGesturePreview();
          if (!isChanging) scheduleAutoAdvance(scenes[activeIndex]);
        }, 280);
      };

      scrollZone.addEventListener('wheel', handleWheel, { passive: false });
      nextButton.addEventListener('pointermove', setRingHover);
      nextButton.addEventListener('pointerleave', clearRingHover);
      nextButton.addEventListener('click', () => {
        const hoveredIndex = nextButton.dataset.hoverIndex;
        goTo(hoveredIndex === undefined ? activeIndex + 1 : Number(hoveredIndex));
      });

      buildTimeline();
      ringArrow.style.transform = 'rotate(0deg)';
      startScene(scenes[activeIndex]);
    };

    roots.forEach(init);
    document.addEventListener('shopify:section:load', (event) => {
      event.target.querySelectorAll?.('[data-simp-movie-shot]').forEach(init);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["simp-product-showcase"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('[data-simp-product-showcase]');
    if (!roots.length) return;

    const init = (root) => {
      if (root.dataset.initialized === 'true') return;
      root.dataset.initialized = 'true';

      const viewport = root.querySelector('[data-showcase-viewport]');
      const stage = root.querySelector('[data-showcase-stage]');
      const track = root.querySelector('[data-showcase-track]');
      const sourceCards = Array.from(root.querySelectorAll('[data-showcase-card]'));
      const filters = root.querySelector('[data-showcase-filters]');
      const previous = root.querySelector('[data-showcase-previous]');
      const next = root.querySelector('[data-showcase-next]');
      const mobileQuery = window.matchMedia('(max-width: 749px)');
      const reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
      let activeFilter = 'all';
      let filteredSources = sourceCards;
      let virtualIndex = 0;
      let previewSize = 5;
      let slotCount = 15;
      let slots = [];
      let touchStartY = null;
      let touchConsumed = false;
      let mobilePinStart = 0;
      let mobilePinEnd = 0;
      let mobilePinHeight = 0;
      let mobileRingSteps = 0;
      let isAnimating = false;
      let isFilterFlipping = false;

      const modulo = (value, divisor) => ((value % divisor) + divisor) % divisor;

      const cancelAnimations = () => {
        slots.forEach((card) => card.getAnimations().forEach((animation) => animation.cancel()));
        isAnimating = false;
      };

      const calculatePreviewSize = () => {
        if (filteredSources.length <= 1) return 0;
        const maximum = mobileQuery.matches ? 3 : 5;
        return Math.min(maximum, Math.floor((filteredSources.length - 1) / 2));
      };

      const createSlots = () => {
        slots.forEach((card) => card.remove());
        previewSize = calculatePreviewSize();
        slotCount = previewSize * 2 + 5;
        slots = Array.from({ length: slotCount }, () => {
          const card = document.createElement('article');
          card.className = 'simp-product-showcase__card is-virtual';
          card.dataset.showcaseVirtual = 'true';
          card.setAttribute('role', 'listitem');
          card.setAttribute('aria-hidden', 'true');
          track.appendChild(card);
          return card;
        });
      };

      const setSource = (card, source) => {
        const sourceKey = `${source.dataset.cardIndex}-${source.dataset.cardCategory}`;
        if (card.dataset.sourceKey === sourceKey) return;
        card.innerHTML = source.innerHTML;
        card.dataset.sourceKey = sourceKey;
        card.dataset.cardIndex = source.dataset.cardIndex;
        card.dataset.cardCategory = source.dataset.cardCategory || '';
        card.dataset.cardCategoryLabel = source.dataset.cardCategoryLabel || '';
      };

      sourceCards.forEach((card) => {
        card.classList.add('is-source');
        card.hidden = true;
      });

      const createFilter = (label, value, selected) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'simp-product-showcase__filter';
        button.dataset.filter = value;
        button.setAttribute('role', 'tab');
        button.setAttribute('aria-selected', selected ? 'true' : 'false');
        button.textContent = label;
        button.addEventListener('click', () => {
          flipToFilter(value);
        });
        filters.appendChild(button);
      };

      const buildFilters = () => {
        if (!filters) return;
        filters.replaceChildren();
        createFilter(filters.dataset.allLabel || 'All', 'all', true);
        const categories = [];
        sourceCards.forEach((card) => {
          const value = card.dataset.cardCategory || '';
          const label = card.dataset.cardCategoryLabel || '';
          if (value && label && !categories.some((category) => category.value === value)) {
            categories.push({ value, label });
          }
        });
        categories.forEach((category) => createFilter(category.label, category.value, false));
      };

      const updateFilterState = () => {
        filters?.querySelectorAll('[data-filter]').forEach((button) => {
          const selected = button.dataset.filter === activeFilter;
          button.classList.toggle('is-active', selected);
          button.setAttribute('aria-selected', selected ? 'true' : 'false');
        });
      };

      const getTarget = (wheelIndex) => {
        const isMobile = mobileQuery.matches;
        const radius = isMobile ? 1650 : 4250;
        const angleStep = isMobile ? 10 : 6;
        const centerY = isMobile ? Math.min(330, viewport.clientHeight * 0.4) : Math.min(390, viewport.clientHeight * 0.46);
        const angle = (wheelIndex - virtualIndex) * angleStep;
        const radians = angle * Math.PI / 180;
        const x = viewport.clientWidth / 2 + radius * Math.sin(radians);
        const y = centerY + radius * (1 - Math.cos(radians));
        const rotation = (wheelIndex - virtualIndex) * angleStep;
        const baseTransform = `translate(-50%, -50%) rotate(${rotation}deg)`;
        const distance = Math.abs(wheelIndex - virtualIndex);
        return {
          x,
          y,
          rotation,
          baseTransform,
          distance,
          visible: distance <= previewSize,
          opacity: distance === 0 ? 1 : distance === 1 ? 0.88 : distance <= previewSize ? 0.62 : 0,
        };
      };

      const applyTarget = (card, target) => {
        card.style.left = `${target.x}px`;
        card.style.top = `${target.y}px`;
        card.style.transform = target.baseTransform;
        card.style.opacity = String(target.opacity);
        card.style.zIndex = String(100 - target.distance);
        card.style.pointerEvents = target.visible ? 'auto' : 'none';
        card.hidden = !target.visible;
        card.classList.toggle('is-active', target.distance === 0);
        card.classList.toggle('is-near', target.distance === 1);
        card.setAttribute('aria-current', target.distance === 0 ? 'true' : 'false');
        card.setAttribute('aria-hidden', target.visible ? 'false' : 'true');
        card.dataset.baseTransform = target.baseTransform;
      };

      const renderWindow = (animate = false, direction = 0) => {
        if (!filteredSources.length) return;
        const halfWindow = Math.floor(slotCount / 2);
        const targets = [];
        for (let wheelIndex = virtualIndex - halfWindow; wheelIndex <= virtualIndex + halfWindow; wheelIndex += 1) {
          const slot = slots[modulo(wheelIndex, slotCount)];
          const source = filteredSources[modulo(wheelIndex, filteredSources.length)];
          const target = getTarget(wheelIndex);
          const oldState = {
            left: slot.style.left || `${target.x}px`,
            top: slot.style.top || `${target.y}px`,
            transform: slot.style.transform || target.baseTransform,
          };
          setSource(slot, source);
          slot.dataset.wheelIndex = String(wheelIndex);
          applyTarget(slot, target);
          targets.push({ slot, target, oldState });
        }

        if (!animate || reducedMotionQuery.matches || !direction) return;

        const step = (mobileQuery.matches ? 10 : 6) * Math.PI / 180;
        const radius = mobileQuery.matches ? 1650 : 4250;
        const whipX = direction * radius * Math.sin(step);
        const whipY = direction * radius * (1 - Math.cos(step));
        const animations = [];
        isAnimating = true;
        targets.forEach(({ slot, target, oldState }, index) => {
          if (!target.visible && !oldState.transform) return;
          const whipTransform = `translate(-50%, -50%) translate3d(${whipX}px, ${whipY}px, 0) rotate(${target.rotation + direction * (mobileQuery.matches ? 10 : 6)}deg)`;
          const animation = slot.animate([
            oldState,
            { left: `${target.x + whipX}px`, top: `${target.y + whipY}px`, transform: whipTransform },
            { left: `${target.x}px`, top: `${target.y}px`, transform: target.baseTransform },
          ], {
            duration: 400,
            delay: index * 8,
            easing: 'cubic-bezier(0.65, 0, 0, 1)',
            fill: 'forwards',
          });
          animations.push(animation.finished.catch(() => undefined));
        });
        Promise.all(animations).then(() => {
          targets.forEach(({ slot, target }) => applyTarget(slot, target));
          isAnimating = false;
        });
      };

      const updateVisibleCards = () => {
        filteredSources = sourceCards.filter((card) => activeFilter === 'all' || card.dataset.cardCategory === activeFilter);
        if (!filteredSources.length) filteredSources = sourceCards;
        createSlots();
        renderWindow(false);
        updateFilterState();
        previous.disabled = filteredSources.length <= 1;
        next.disabled = filteredSources.length <= 1;
      };

      const flipToFilter = async (value) => {
        if (isFilterFlipping || value === activeFilter) return;
        isFilterFlipping = true;
        cancelAnimations();
        const currentCards = slots.filter((card) => !card.hidden);
        if (!reducedMotionQuery.matches) {
          await Promise.all(currentCards.map((card) => card.animate([
            { transform: card.dataset.baseTransform || card.style.transform },
            { transform: `${card.dataset.baseTransform || card.style.transform} rotateY(90deg)` },
          ], { duration: 200, easing: 'cubic-bezier(0, 0, 0, 1)', fill: 'forwards' }).finished.catch(() => undefined)));
        }
        activeFilter = value;
        virtualIndex = 0;
        updateVisibleCards();
        const enteringCards = slots.filter((card) => !card.hidden);
        enteringCards.forEach((card) => {
          const baseTransform = card.dataset.baseTransform || card.style.transform;
          card.style.transform = `${baseTransform} rotateY(270deg)`;
        });
        if (!reducedMotionQuery.matches) {
          await Promise.all(enteringCards.map((card, index) => card.animate([
            { transform: `${card.dataset.baseTransform} rotateY(270deg)` },
            { transform: `${card.dataset.baseTransform} rotateY(360deg)` },
          ], { duration: 500, delay: index * (500 / Math.max(1, enteringCards.length - 1)), easing: 'cubic-bezier(0, 0, 0, 1)', fill: 'forwards' }).finished.catch(() => undefined)));
        }
        enteringCards.forEach((card) => applyTarget(card, getTarget(Number(card.dataset.wheelIndex || virtualIndex))));
        isFilterFlipping = false;
      };

      const move = (direction) => {
        if (isAnimating || isFilterFlipping || filteredSources.length <= 1) return;
        virtualIndex += direction;
        renderWindow(true, direction);
      };

      const syncMobilePin = () => {
        if (!mobileQuery.matches) {
          stage.classList.remove('is-pinned');
          stage.style.marginBottom = '';
          return;
        }

        const shouldPin = window.scrollY >= mobilePinStart && window.scrollY < mobilePinEnd;
        const isPinned = stage.classList.contains('is-pinned');
        if (shouldPin && !isPinned) {
          stage.style.marginBottom = `${mobilePinHeight}px`;
          stage.classList.add('is-pinned');
          mobileRingSteps = 0;
        } else if (!shouldPin && isPinned) {
          stage.classList.remove('is-pinned');
          stage.style.marginBottom = '';
        }
      };

      const releaseMobilePin = (direction) => {
        stage.classList.remove('is-pinned');
        stage.style.marginBottom = '';
        if (direction > 0) mobilePinEnd = Math.min(mobilePinEnd, window.scrollY);
        if (direction < 0) mobilePinStart = Math.max(mobilePinStart, window.scrollY + 1);
      };

      const consumeMobileRingStep = (direction) => {
        if (!mobileQuery.matches || !stage.classList.contains('is-pinned')) return;
        mobileRingSteps += 1;
        if (mobileRingSteps >= Math.max(5, filteredSources.length)) releaseMobilePin(direction);
      };

      const measureMobilePin = () => {
        if (!mobileQuery.matches) {
          syncMobilePin();
          return;
        }

        const isPinned = stage.classList.contains('is-pinned');
        if (isPinned) {
          stage.classList.remove('is-pinned');
          stage.style.marginBottom = '';
        }
        const scrollOffset = window.scrollY;
        mobilePinStart = stage.getBoundingClientRect().top + scrollOffset;
        mobilePinHeight = stage.offsetHeight;
        const sectionBottom = root.getBoundingClientRect().bottom + scrollOffset;
        mobilePinEnd = Math.max(mobilePinStart, sectionBottom - mobilePinHeight);
        syncMobilePin();
      };

      const handleTouchStart = (event) => {
        if (!mobileQuery.matches || event.touches.length !== 1) return;
        touchStartY = event.touches[0].clientY;
        touchConsumed = false;
      };

      const handleTouchMove = (event) => {
        if (!mobileQuery.matches || touchStartY === null || touchConsumed || event.touches.length !== 1) return;
        const deltaY = touchStartY - event.touches[0].clientY;
        if (Math.abs(deltaY) < 18) return;

        const direction = deltaY > 0 ? 1 : -1;
        event.preventDefault();
        touchConsumed = true;
        move(direction);
        consumeMobileRingStep(direction);
      };

      const handleTouchEnd = () => {
        touchStartY = null;
        touchConsumed = false;
      };

      const handleWheel = (event) => {
        if (Math.abs(event.deltaY) < 8) return;
        if (mobileQuery.matches && !stage.classList.contains('is-pinned')) return;
        const direction = event.deltaY > 0 ? 1 : -1;
        event.preventDefault();
        move(direction);
        consumeMobileRingStep(direction);
      };

      previous.addEventListener('click', () => move(-1));
      next.addEventListener('click', () => move(1));
      viewport.addEventListener('touchstart', handleTouchStart, { passive: true });
      viewport.addEventListener('touchmove', handleTouchMove, { passive: false });
      viewport.addEventListener('touchend', handleTouchEnd, { passive: true });
      viewport.addEventListener('touchcancel', handleTouchEnd, { passive: true });
      viewport.addEventListener('wheel', handleWheel, { passive: false });
      root.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft') move(-1);
        if (event.key === 'ArrowRight') move(1);
      });
      window.addEventListener('resize', () => {
        window.requestAnimationFrame(() => {
          updateVisibleCards(false);
          measureMobilePin();
        });
      }, { passive: true });
      window.addEventListener('scroll', syncMobilePin, { passive: true });

      buildFilters();
      updateVisibleCards(false);
      measureMobilePin();
    };

    roots.forEach(init);
    document.addEventListener('shopify:section:load', (event) => {
      event.target.querySelectorAll?.('[data-simp-product-showcase]').forEach(init);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
